module.exports = "https://cdn.thelire.com/ins/resource/ico_tab5_contact@3x.49cdcb67f7ac37a7571723cb2f0f146b.png";